import React, { useState, useEffect } from 'react';
import styles from './sendOfferEmailsToCandidatesModal.module.scss';
import { Container, Col, Modal, Button, Row,  } from 'react-bootstrap';
import EmailReview from './emailReview';
import EmailDetails from './emailDetails';
import CSSLoader from '../../../shared/cssLoader';
import { CustomButton } from '../../../shared/customButton';
import { getCandidateOfferEmailConfig } from '../../../../services/util/offerHandling';
import { sendOfferEmail } from '../../../../services/util/offerHandling';
import { checkCompanyEmailAccountConnection } from '../../../../services/util/company';

function SendASingleEmailsToCandidates(props) {
    let [step, setStep] = useState(1);
    let [emailData,setEmailData] = useState({
        templateWrapper:'',
        templateBody:'',
        email_subject:'',
        email_account_choice:null
    })
    let [isLoading, setLoading] = useState(false);
    let [submissionLoading,setSubmissionLoading] = useState(false);
    let [offerSessionID, setofferSessionID] = useState(props.offerSessionID);
    let [emailTemplateType, setEmailTemplateType] = useState('');

    // let [candidateEmailList, setCandidateEmailList] = useState([]);
    // let [candidateIDList, setCandidateIDList] = useState([]);
    let [showEmailConnectModal, setShowEmailConnectModal] = useState(false);
    let [showEmailModal, setShowEmailModal] = useState(false);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function redirectToCompanySettings() {
        window.location.replace('/app/company/settings/integrations')
    }

    const onSubmitEmailData = (values) =>{
        setEmailData((prevState) => ({
            ...prevState,
            templateBody: values.emailBody,
            email_subject: values.emailSubject

        }));
        nextPage(2);
    }

    const checkCompanyEmailConnected = async () => {
        setLoading(true);
        let respond = await checkCompanyEmailAccountConnection();
        if (respond.success === true) {
            if (respond.data.is_company_ready_for_email_automation) {
                getInitialValues();
            } else {
                setShowEmailConnectModal(true);
                setLoading(false);
            }
        } else {
        }
    }

    const getInitialValues = async() =>{
        let respond;
        if (props.emailTemplateName === 'SEND_OFFER_EMAIL') {
            respond = await getCandidateOfferEmailConfig();
        }
            if(respond.success === true){
                setEmailData(respond.data);
                setShowEmailModal(true);
                setLoading(false);
                if (props.emailTemplateName === 'SEND_OFFER_EMAIL') {
                    setEmailTemplateType('Send Offer Email');
                }
            }else{
                setShowEmailModal(true);
                setLoading(false);
            }
    }

    const submitEmailTemplateValues = async() =>{
        setSubmissionLoading(true);
        let respond;
        if (props.emailTemplateName === 'SEND_OFFER_EMAIL') {
            respond = await sendOfferEmail(offerSessionID, emailData.email_subject, emailData.templateBody);
        }
        if(respond.success === true){
            setSubmissionLoading(false);
            props.handleClose();
            props.refreshData();
        }else{
            setSubmissionLoading(false);
        }
    }

    useEffect(() => {
        checkCompanyEmailConnected();
    }, []);
    
    return (
            (<div>
                
                                <Modal
                                    show={props.showModal}
                                    onHide={props.handleClose}
                                    backdrop="static"
                                    keyboard={false}
                                    centered
                                    size="md"
                                >
                                    <Modal.Body>
                                        {isLoading === false ?
                                            ( <>
                                                    {/* email connect alert */}
                                                    {showEmailConnectModal &&< div className={styles.modalBody}>
                                                        <div className={styles.popUpBoxTopicDiv}>
                                                            <p className={styles.popUpBoxTopic}>Connect Company Email</p>
                                                        </div>
                                                        <Container>
                                                            <Col>
                                                                <p className={styles.popUpBoxMessage}>Company email haven't configured.</p>
                                                            </Col>
                                                            <Col>
                                                                <p className={styles.popUpBoxMessageDesc}>Before sending email, connect one of your organization’s Google or Office 365 Email Accounts (ex :- careers@companyxxx.com). </p>
                                                            </Col>
                                                            <Container>
                                                                <Row>
                                                                    <Col className="mb-2">
                                                                        <CustomButton
                                                                            name="respondAcceptBtn"
                                                                            buttonType="button"
                                                                            type="defaultBtn"
                                                                            label="Cancel"
                                                                            handleClick={(() => setShowEmailConnectModal(false)) && (props.handleClose)}
                                                                        />
                                                                    </Col>
                                                                    <Col>
                                                                        <CustomButton
                                                                            name="respondAcceptBtn"
                                                                            buttonType="button"
                                                                            type="primaryBtn"
                                                                            label="Connect Email"
                                                                            handleClick={redirectToCompanySettings}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Container>

                                                        </Container>
                                                        </div>}

                                                        {/* send email*/}
                                                    {showEmailModal &&<>
                                                        <div className={styles.modalCancelBtnDiv}>
                                                                <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </Button>
                                                            </div>

                                                            <div className={styles.modalHeaderDiv}>
                                                                <h2 className={styles.modalHeader}>{emailTemplateType}</h2>
                                                            </div>

                                                            <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                                                                <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                                                                    <div className={styles.stepActive}>1</div>
                                                                    <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                                                                </div>
                                                            </Col>

                                                            <Col >
                                                            {step === 1 && props.showModal === true && <EmailDetails onSubmitEmailData={onSubmitEmailData} closeModal={props.handleClose} emailData={emailData} candidateEmail={props.candidateEmail} />}
                                                                            {step === 2 && props.showModal === true && <EmailReview previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} emailData={emailData} submitEmailTemplateValues={submitEmailTemplateValues} candidateEmail={props.candidateEmail} submissionLoading={submissionLoading}/>}
                                                            </Col>
                                                    </>}
                                                    </> ) 
                                                    :
                                                    (<div className='mt-5'>
                                                        <Col sm={{ span: 4, offset: 4 }}>
                                                            <CSSLoader />
                                                        </Col>
                                                     </div>)
                                        }
                                    </Modal.Body>
                                </Modal>
                    
            </div>)
    )
}

export default SendASingleEmailsToCandidates;
